import "@popperjs/core";
require('bootstrap');

var Masonry= require('masonry-layout');
var elem = document.querySelector('.grid');
var elemW = document.querySelector('.wechat-container');

if (elem) {
    var msnry = new Masonry(elem, {
        itemSelector: '.grid-item',
        columnWidth: 80,
        percentPosition: true
    });
}


//comportement du menu mobile
// JavaScript pour gérer le comportement du menu
const screenSize = 1071; // Taille d'écran en pixels pour déclencher le comportement

function toggleSubMenu(e) {
    e.preventDefault();
    const menuItem = e.currentTarget;
    const subMenu = menuItem.querySelector(".sub-menu");

    menuItem.classList.toggle("is-open");
    subMenu.style.display = menuItem.classList.contains("is-open") ? "block" : "none";
}

function handleResize() {
    const windowWidth = window.innerWidth;

    const menuItems = document.querySelectorAll(".first-nav-mobile .menu-item-has-children");

    menuItems.forEach(menuItem => {
        menuItem.removeEventListener("click", toggleSubMenu);

        if (windowWidth < screenSize) {
            menuItem.addEventListener("click", toggleSubMenu);
        } else {
            menuItem.classList.remove("is-open");
            const subMenu = menuItem.querySelector(".sub-menu");
            subMenu.style.display = "none";
        }
    });
}

// Empêche la propagation de l'événement click pour les liens dans la classe "sub-menu"
function stopPropagationForLinks(e) {
    e.stopPropagation();
}

// Attachez un gestionnaire d'événement pour la fenêtre redimensionnée
window.addEventListener("resize", handleResize);

// Appelez handleResize pour initialiser le comportement
handleResize();

// Ajoutez un gestionnaire d'événements pour empêcher la propagation des clics sur les liens dans la classe "sub-menu"
const subMenuLinks = document.querySelectorAll(".sub-menu a");
subMenuLinks.forEach(link => {
    link.addEventListener("click", stopPropagationForLinks);
});

//gestion du burger
const btnMobileActivate = document.querySelector(".btn-mobile-activate");

function toggleMenu() {
    btnMobileActivate.classList.toggle("is-active");
}

btnMobileActivate.addEventListener("click", toggleMenu);
